import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { clearAutoRefresh } from '../utils/tokenRefresh';

export const Header: React.FC = () => {
  const navigate = useNavigate();
  const isLoggedIn = !!localStorage.getItem('access_token');
  const user = localStorage.getItem('user');
  const username = user ? JSON.parse(user).username : '';

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
    clearAutoRefresh();
    navigate('/login');
  };

  return (
    <header className="header">
      <Link to="/" className="header-title">Lists</Link>
      <nav className="header-nav">
        {isLoggedIn ? (
          <>
            <Link to="/candidates" className="header-link">Candidates</Link>
            <span className="header-link">{username}</span>
            <button onClick={handleLogout} className="btn btn-sm">Log out</button>
          </>
        ) : (
          <>
            <Link to="/login" className="header-link">Log in</Link>
            <Link to="/signup" className="header-link">Sign up</Link>
          </>
        )}
      </nav>
    </header>
  );
};
